import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { ToolbarButton } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { useImageEditingContext } from './context';
export default function FormControls() {
  const {
    isInProgress,
    apply,
    cancel
  } = useImageEditingContext();
  return createElement(Fragment, null, createElement(ToolbarButton, {
    onClick: apply,
    disabled: isInProgress
  }, __('Apply')), createElement(ToolbarButton, {
    onClick: cancel
  }, __('Cancel')));
}
//# sourceMappingURL=form-controls.js.map